import { render, staticRenderFns } from "./ConfirmEmailPage.vue?vue&type=template&id=1f29887a&scoped=true&"
import script from "./ConfirmEmailPage.vue?vue&type=script&lang=ts&"
export * from "./ConfirmEmailPage.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmEmailPage.vue?vue&type=style&index=0&id=1f29887a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f29887a",
  null
  
)

export default component.exports